export default __webpack_public_path__ + "static/media/scritta.cc0f3746.svg";